import { SERVICES_SERVER_BASE_URL } from '../../config/app.constants'
import { AppError } from '../../utils/appError'
import { authAxios } from '../../utils/authAxios'
import {
  ApiFindReserveGuestAppResponse,
  ApiReserveDataGuestAppResponse,
  RoomData,
} from './findreserve_guestapp.types'

export const apiFindReserveGuestApp = async ({
  guestCode,
  userLang,
}: {
  guestCode: string
  userLang: string
}): Promise<ApiReserveDataGuestAppResponse> => {
  const response = await authAxios.post<ApiFindReserveGuestAppResponse>(
    `${SERVICES_SERVER_BASE_URL}/findreserve_guestapp_v2`,
    {
      guestCode,
      userLang,
    }
  )

  if (!response.data.ok) {
    // eslint-disable-next-line prefer-promise-reject-errors
    if (response.data.status === 'NOT_FOUND') {
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject(
        new AppError({ message: response.data.error, status: response.data.status })
      )
    }
    return Promise.reject(response)
  }
  const { reserveDataGuestAppResponseList } = response.data
  const reserveData = reserveDataGuestAppResponseList[0]
  const serverPath = (reserveData.serverPath ?? '').match(/^.+?(?=\/)/)?.[0] ?? ''
  if (reserveData.keyServerFallback) {
    return { ...normalizeReducedReserveData(reserveData), serverPath }
  }
  return { ...reserveData, serverPath }
}

/**
 * Modo reducido (el PMS no responde y la reserva viene del servidor de llaves): el servidor de
 * servicios solo rellena los datos de apertura. Las listas que no vengan se dejan vacías para
 * que ninguna pantalla falle al recorrerlas.
 */
export const normalizeReducedReserveData = (
  reserveData: ApiReserveDataGuestAppResponse
): ApiReserveDataGuestAppResponse => {
  const roomData: Partial<RoomData> = reserveData.roomData ?? {}
  return {
    ...reserveData,
    billList: reserveData.billList ?? [],
    conditionList: reserveData.conditionList ?? [],
    countryDataList: reserveData.countryDataList ?? [],
    countryList: reserveData.countryList ?? [],
    documentList: reserveData.documentList ?? [],
    identifierTypeList: reserveData.identifierTypeList ?? [],
    manualList: reserveData.manualList ?? [],
    phoneList: reserveData.phoneList ?? [],
    provinceList: reserveData.provinceList ?? [],
    roomTypeImageUrlList: reserveData.roomTypeImageUrlList ?? [],
    sexList: reserveData.sexList ?? [],
    travelRegisteredList: reserveData.travelRegisteredList ?? [],
    travelRegistrationRelationShipEnumList:
      reserveData.travelRegistrationRelationShipEnumList ?? [],
    roomData: {
      ...(roomData as RoomData),
      dispositiveList: (roomData.dispositiveList ?? []).map((dispositive) => ({
        ...dispositive,
        commandList: dispositive.commandList ?? [],
        videoList: dispositive.videoList ?? [],
      })),
    },
  }
}
